import React from 'react';
import Popper from 'popper.js';
import WarningIcon from '@material-ui/icons/Warning';
import CheckIcon from '@material-ui/icons/Check';
import { PAGE, REFERRAL_STATUS } from 'placement/const';

type Props = {
    specialConsiderations: string[];
    page: PAGE;
    referralStatus: REFERRAL_STATUS;
}

export function ReferralToolTip({ specialConsiderations, page, referralStatus }: Props) {
    const [tooltipShow, setTooltipShow] = React.useState(false);
    const btnRef = React.useRef(null);
    const tooltipRef = React.useRef(null);
    const openLeftTooltip = () => {
        new Popper(btnRef.current!, tooltipRef.current!, {
            placement: 'right'
        });
        setTooltipShow(true);
    };
    const closeLeftTooltip = () => {
        setTooltipShow(false);
    };

    if (!(page === PAGE.PROVIDER_REQUEST && referralStatus === REFERRAL_STATUS.MATCHED) &&
        specialConsiderations.length === 0) {
        return <React.Fragment />;
    }

    return (
        <>
            <div className='flex flex-wrap'>
                <div className='w-full text-center'>
                    {
                        (page === PAGE.PROVIDER_REQUEST && referralStatus === REFERRAL_STATUS.MATCHED) ?
                        <div className='mr-1 mb-1 text-green-400'>
                            <CheckIcon />
                        </div> :
                        <button
                            className='font-bold uppercase text-sm rounded outline-none focus:outline-none mr-1 mb-1'
                            type='button'
                            style={{ transition: 'all .15s ease' }}
                            onMouseEnter={openLeftTooltip}
                            onMouseLeave={closeLeftTooltip}
                            ref={btnRef}
                        >

                            <WarningIcon />
                        </button>
                    }
                    <div
                        data-testid="referral-tooltip"
                        className={
                            (tooltipShow ? '' : 'hidden ') +
                            'bg-black border-0 ml-3 block z-50 font-normal leading-normal min-w-xl max-w-full text-left no-underline break-words rounded-lg'
                        }
                        ref={tooltipRef}
                    >
                        <div>
                            <div className='bg-black text-white opacity-75 text-xs px-2 pt-2 mb-0 rounded-t-lg'>
                                Special Considerations:
                            </div>
                            <div className='text-white text-sm font-semi-bold py-2 pl-8 pr-2'>
                                <ul className='list-disc'>
                                    {
                                        specialConsiderations.map((consideration) => (
                                            <li key={consideration}>{consideration}</li>
                                        ))
                                    }
                                </ul>
                                <svg className='absolute text-black h-4 w-4'
                                    style={{ left: '-1rem', top: '40%', transform: 'rotate(90deg)' }} x='0px' y='0px' viewBox='0 0 255 255' xmlSpace='preserve'><polygon className='fill-current' points='0,0 127.5,127.5 255,0' /></svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
